import React from 'react';
import { IUserSubMenu } from '../UserSubMenus';
import { Icon, IconType } from '@repo/ui/components';

export interface ISettingHeaderItemProps {
  item: IUserSubMenu;
  onReset(): void;
}

export const SettingHeaderItem = (props: ISettingHeaderItemProps) => (
  <>
    <button className="cursor-pointer" onClick={() => props.onReset()}>
      <Icon icon={IconType.NewNextArrowLeft} aria-hidden width={24} height={24} />
    </button>
    <div className="text-xs/[170%] font-semibold">{props.item.title}</div>
  </>
);
